if (!Symbol.hasInstance)
    (Symbol as any).hasInstance = Symbol.for("hasInstance");

/**
    * Náhrada klasického instanceof používajícího Symbol.hasInstance v ES6+ pro aplikace běžíci v ES5 v IE a jiných starších prohlížečích.
    * Hlavně pro použítí s interfejsi
    * @param value Hodnota u které chceme zjistit dědičnost
    * @param interfaceClass Třída/Interface implementující metodu [Symbol.hasInstance]
    */
export function instanceOf<T>(value: any, interfaceClass: { new(): T }): value is T {
    if (typeof value !== "object")
        return false;
    const checkFunc = interfaceClass[Symbol.hasInstance];
    return checkFunc && checkFunc(value);
}

/**
    * Na základě názvu ctoru porovná, jestli je objekt instancí některého ze zadaných objektů (Workaround pro cross-frame objekty).
    * Prochází prototypy hledaného objektu a porovnává je na základě názvu ctoru.
    * POZOR: Není typově bezpečný. Může vracet true v případě shodného názvu v hiearchii. Např. instanceOf(MyNamespaceA.MyObject, MyNamespaceB.MyObject) bude vracet true, protože název ctoru v obou případech bude "MyObject".
    * @param obj Objekt, který má být ověřen
    * @param objType typ(y) pro porovnání
    */
/*export function instanceOf(obj: any, ...objType: any[]) {
    for (let t of objType) {
        while (obj != null) {
            if (obj.constructor.name === t.name)
                return true;
            obj = Reflect.getPrototypeOf(obj);
        }
    }
    return false;
}*/

/**
    * Na základě názvu ctoru porovná, jestli je objekt instancí některého ze zadaných objektů (Workaround pro cross-frame objekty).
    * @param value instance, jejíž typ se má kontrolvoat
    * @param objClass typ, proti kterému se ověřuje
    */
export function contextlessInstanceOf<T>(value: any, objClass: { new(): T }): value is T;
export function contextlessInstanceOf<T>(value: any, objClass: any): value is T;
export function contextlessInstanceOf(value: any, objClass: any): boolean {
    while (value != null) {
        if (value.constructor.name === objClass.name) {
            return true; //nelze použít rekurzivní kontrolu podle názvu ctoru předků. TC: obj typu EOWSessionTimeout má předka OWException, ale Reflect.getPrototypeOf(obj).constructor.name === "EOWSessionTimeout"
        }
        value = Object.getPrototypeOf(value);
    }
    return false;
}
